import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import useAuthStore from "../store/authStore";
import styles from "./Auth.module.css";
import LoadingScreen from "../components/chat/LoadingScreen";

const Login = () => {
  const navigate = useNavigate();
  const { login, isLoading } = useAuthStore();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showLoader, setShowLoader] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(form);
    if (result.success) {
      if (result.requires2FA) {
        toast("Enter the 2FA code sent to your email");
        navigate("/verify-2fa", { state: { email: result.email, devOtp: result.devOtp } });
      } else {
        setShowLoader(true);
        setTimeout(() => navigate("/"), 1800);
      }
    } else toast.error(result.message);
  };

  if (showLoader) return <LoadingScreen message="Signing you in…" />;

  return (
    <div className={styles.authPage}>
      <div className={styles.authCard}>
        <div className={styles.logo}>
          <div className={styles.logoMark}>💬</div>
          <h1>Chatify</h1>
        </div>
        <p className={styles.subtitle}>Sign in to continue chatting</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label>Email</label>
            <input type="email" placeholder="you@example.com" value={form.email} required
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className={styles.field}>
            <label>Password</label>
            <input type="password" placeholder="••••••••" value={form.password} required
              onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <button type="submit" className={styles.submitBtn} disabled={isLoading}>
            {isLoading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className={styles.switchAuth}>
          Don't have an account? <Link to="/register">Create one free</Link>
        </p>
      </div>
    </div>
  );
};
export default Login;
